import React, { useRef, useEffect } from "react";
import styled from "@emotion/styled";
import { Section, BackgroundVariantProps } from "../Section";
import { isPathway } from "../utils/is-pathway-to-net-zero";

export const WPContent = styled.div<{ isPathway?: boolean }>`
  h2 {
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    letter-spacing: 0px;
    margin-bottom: 34px;
    line-height: 1.4;
    padding-top: ${(props) => (props.isPathway ? "32px" : "0")};
  }

  h3 {
    text-align: left;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 0px;
    margin-bottom: 20px;
  }

  p {
    font-size: 18px;
    word-wrap: break-word;
    margin-bottom: 36px;
    line-height: 1.6;
  }

  a {
    color: ${(props) => props.theme.colors.fern};
    text-decoration: none;
    transition: all 0.3s;
    word-wrap: break-word;

    &:focus,
    &:hover {
      text-decoration: underline;
    }
  }

  br {
    content: "";
    display: block;
    margin-bottom: 16px;
  }

  ul {
    list-style: disc;
  }

  li {
    font-size: 18px;
    line-height: 1.6;
    list-style: inherit;
    margin: 0 0 9px;
  }

  img {
    width: 100%;
    height: auto;
  }

  iframe {
    padding-bottom: ${(props) => (props.isPathway ? "32px" : "0")};
  }
`;

export type TextWidgetV2Props = {
  body: string;
  slug?: string | string[];
} & BackgroundVariantProps;

export const TextWidgetV2 = ({ body, ...props }: TextWidgetV2Props) => {
  const ref = useRef<null | HTMLDivElement>(null);

  useEffect(() => {
    if (typeof window === "undefined") return;
    // Create a 'tiny' document and parse the html string
    const slotHtml = document.createRange().createContextualFragment(body);
    // Append it so it can be executed (allows <script> etc.)
    if (ref && ref.current) {
      ref.current.appendChild(slotHtml);
    }
  }, [ref, body]);

  const isPathwayPage = isPathway(props?.slug);
  // Optional background colour for the section from Wordpress
  return (
    <Section {...props} isLarge={isPathwayPage}>
      <WPContent ref={ref} isPathway={isPathwayPage} />
    </Section>
  );
};
